<cab-doc-page [page]="StaticContentPage.AffiliateAgreement" />
